export default __webpack_public_path__ + "static/media/logo_vinci.d07b1f73.svg";